<template>
    <div class>
        <CampaignItem
            v-for="campaign in campaigns"
            :key="campaign.id"
            :campaign="campaign"
        ></CampaignItem>
        <div
            class="text-center"
            v-if="isLoaded && !isHaveItem"
            v-html="lbl.promotion.comingSoon"
        ></div>
    </div>
</template>
<script>
//component
import CampaignItem from "./CampaignItem.vue";
//service
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";
// mixins
import LocaleMixin from "@/mixin/LocaleMixin";
import { CampaignConfigModel } from "@/core/Campaign/model/CampaignConfigModel.js";

/**
 * @event onLoaded
 */
export default {
    name: "CampaignList",
    components: {
        CampaignItem,
    },
    mixins: [LocaleMixin],
    props: {
        initListConfig: { type: Object },
        initFilterConfig: { type: Object },
        modalController: { type: Object },
    },
    data: function () {
        return {
            listConfig: null,
            filterConfig: null,

            campaigns: [],

            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
            pageYOffsetTemp: 0,
            timerId: null,
        };
    },
    created: function () {
        this.setScrollLoadMore();

        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;

        if (this.listConfig != null && this.filterConfig != null) {
            this.getList();
        }
    },
    beforeUnmount: function () {
        window.onscroll = null;
    },
    methods: {
        reinitList: function (listConfig, listFilter) {
            this.listConfig = listConfig;
            this.filterConfig = listFilter;
            this.campaigns = [];
            this.getList();
        },
        getList: function () {
            return new Promise((resolve) => {
                this.isLoading = true;
                this.modalController.loadingModal.show();

                BzbsCampaign.apiGetCampaign(
                    this.listConfig,
                    this.filterConfig
                ).subscribe(
                    async (campaigns) => {
                        this.listConfig.intSkip +=
                            this.listConfig.defaultTopAmount;
                        //check is there are more campaign.
                        if (
                            campaigns &&
                            campaigns.length < this.listConfig.defaultTopAmount
                        ) {
                            this.listConfig.isSeeMoreEnable = false;
                        }

                        //reinitialize list if no skip.
                        if (
                            this.listConfig.intSkip ==
                            this.listConfig.defaultTopAmount
                        ) {
                            this.campaigns = [];
                        }

                        for (var campaign of campaigns) {
                            //TODO: Add GA Tracking.
                            let campaignDetail = await this.getCampaignDetail(campaign.id);
                            
                            if (campaignDetail) {
                                this.campaigns.push(campaignDetail);
                            } else {
                                this.campaigns.push(campaign);
                            }
                        }
                        this.modalController.loadingModal.hide();
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem =
                            this.campaigns.length > 0 ? true : false;

                        resolve();
                        this.$emit("onLoaded");
                    },
                    (err) => {
                        this.modalController.loadingModal.hide();
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.errorApi(err);

                        this.$emit("onLoaded");
                        resolve();
                    }
                );
            });
        },
        getCampaignDetail(campaignId) {
            return new Promise((resolve) => {
                let campaignConfig = new CampaignConfigModel();
                campaignConfig.strId = campaignId;
                
                BzbsCampaign.apiGetCampaignDetail(campaignConfig).subscribe(
                    (res) => resolve(res),
                    (err) => {
                        console.error("Failed to fetch detail for campaign " + campaignId, err);
                        resolve(null);
                    }
                );
            });
        },
        loadMore: async function () {
            console.log("load more list", this.listConfig.isSeeMoreEnable);
            if (!this.listConfig.isSeeMoreEnable || this.isLoading) {
                return;
            }

            this.modalController.loadingModal.show();
            await this.getList();
            this.modalController.loadingModal.hide();
        },
        setScrollLoadMore: function () {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;

                let offsetYNew = window.pageYOffset;
                if (this.pageYOffsetTemp < offsetYNew) {
                    // direction scroll down
                    if (bottomOfWindow) {
                        // debounce load more
                        clearTimeout(this.timerId);
                        this.timerId = setTimeout(() => {
                            this.loadMore();
                        }, 250);
                    }
                }
                this.pageYOffsetTemp = offsetYNew;
            };
        },
    },
};
</script>
<style lang="scss" scoped>
</style>
